// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes image-module_cw-spin__tBiIy {
    to {
        transform: rotate(360deg);
    }
}

.image-module_spinner__Adj1E {
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-top-color: currentColor;
    border-radius: 50%;
    animation: image-module_cw-spin__tBiIy 0.6s linear infinite;
}

.image-module_spinnerContainer__bP2y_ {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    animation: image-module_fadeIn__QJ2KP 0s linear forwards;
    animation-delay: var(--spinner-delay, 300ms);
}

@keyframes image-module_fadeIn__QJ2KP {
    to {
        opacity: 1;
    }
}

.image-module_container__mcZT4 {
    --cw-img-width: 24px;
    --cw-img-height: 24px;
    --cw-img-radius: 0px;
    --cw-img-margin-top: 0;
    --cw-img-margin-right: 0;
    --cw-img-margin-bottom: 0;
    --cw-img-margin-left: 0;
    --cw-img-overflow: hidden;

    position: relative;
    overflow: var(--cw-img-overflow);
    width: var(--cw-img-width);
    height: var(--cw-img-height);
    border-radius: var(--cw-img-radius);
    margin: var(--cw-img-margin-top) var(--cw-img-margin-right) var(--cw-img-margin-bottom) var(--cw-img-margin-left);
    flex-shrink: 0;
}

/* Alignment */
.image-module_alignTopLeft__eb1s5 { position: absolute; top: 0; left: 0; }
.image-module_alignTopCenter__oPHGL { position: absolute; top: 0; left: 50%; transform: translateX(-50%); }
.image-module_alignTopRight__qfpYA { position: absolute; top: 0; right: 0; }
.image-module_alignCenterLeft__tP4g_ { position: absolute; top: 50%; left: 0; }
.image-module_alignCenter__Iaebk { position: absolute; top: 50%; left: 50%; transform: translateX(-50%); }
.image-module_alignCenterRight__JULUU { position: absolute; top: 50%; right: 0; }
.image-module_alignBottomLeft__XUPjh { position: absolute; bottom: 0; left: 0; }
.image-module_alignBottomCenter__k2FX1 { position: absolute; bottom: 0; left: 50%; transform: translateX(-50%); }
.image-module_alignBottomRight__MZd7d { position: absolute; bottom: 0; right: 0; }
`, "",{"version":3,"sources":["webpack://./../../packages/core-widgets/src/image/image.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,kBAAkB;IAClB,2DAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,wDAAoC;IACpC,4CAA4C;AAChD;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,uBAAuB;IACvB,yBAAyB;;IAEzB,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;IAC1B,4BAA4B;IAC5B,mCAAmC;IACnC,iHAAiH;IACjH,cAAc;AAClB;;AAEA,cAAc;AACd,oCAAgB,kBAAkB,EAAE,MAAM,EAAE,OAAO,EAAE;AACrD,sCAAkB,kBAAkB,EAAE,MAAM,EAAE,SAAS,EAAE,2BAA2B,EAAE;AACtF,qCAAiB,kBAAkB,EAAE,MAAM,EAAE,QAAQ,EAAE;AACvD,uCAAmB,kBAAkB,EAAE,QAAQ,EAAE,OAAO,EAAE;AAC1D,mCAAe,kBAAkB,EAAE,QAAQ,EAAE,SAAS,EAAE,2BAA2B,EAAE;AACrF,wCAAoB,kBAAkB,EAAE,QAAQ,EAAE,QAAQ,EAAE;AAC5D,uCAAmB,kBAAkB,EAAE,SAAS,EAAE,OAAO,EAAE;AAC3D,yCAAqB,kBAAkB,EAAE,SAAS,EAAE,SAAS,EAAE,2BAA2B,EAAE;AAC5F,wCAAoB,kBAAkB,EAAE,SAAS,EAAE,QAAQ,EAAE","sourcesContent":["@keyframes cw-spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.spinner {\n    border: 2px solid rgba(0, 0, 0, 0.1);\n    border-top-color: currentColor;\n    border-radius: 50%;\n    animation: cw-spin 0.6s linear infinite;\n}\n\n.spinnerContainer {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    animation: fadeIn 0s linear forwards;\n    animation-delay: var(--spinner-delay, 300ms);\n}\n\n@keyframes fadeIn {\n    to {\n        opacity: 1;\n    }\n}\n\n.container {\n    --cw-img-width: 24px;\n    --cw-img-height: 24px;\n    --cw-img-radius: 0px;\n    --cw-img-margin-top: 0;\n    --cw-img-margin-right: 0;\n    --cw-img-margin-bottom: 0;\n    --cw-img-margin-left: 0;\n    --cw-img-overflow: hidden;\n\n    position: relative;\n    overflow: var(--cw-img-overflow);\n    width: var(--cw-img-width);\n    height: var(--cw-img-height);\n    border-radius: var(--cw-img-radius);\n    margin: var(--cw-img-margin-top) var(--cw-img-margin-right) var(--cw-img-margin-bottom) var(--cw-img-margin-left);\n    flex-shrink: 0;\n}\n\n/* Alignment */\n.alignTopLeft { position: absolute; top: 0; left: 0; }\n.alignTopCenter { position: absolute; top: 0; left: 50%; transform: translateX(-50%); }\n.alignTopRight { position: absolute; top: 0; right: 0; }\n.alignCenterLeft { position: absolute; top: 50%; left: 0; }\n.alignCenter { position: absolute; top: 50%; left: 50%; transform: translateX(-50%); }\n.alignCenterRight { position: absolute; top: 50%; right: 0; }\n.alignBottomLeft { position: absolute; bottom: 0; left: 0; }\n.alignBottomCenter { position: absolute; bottom: 0; left: 50%; transform: translateX(-50%); }\n.alignBottomRight { position: absolute; bottom: 0; right: 0; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `image-module_spinner__Adj1E`,
	"cw-spin": `image-module_cw-spin__tBiIy`,
	"spinnerContainer": `image-module_spinnerContainer__bP2y_`,
	"fadeIn": `image-module_fadeIn__QJ2KP`,
	"container": `image-module_container__mcZT4`,
	"alignTopLeft": `image-module_alignTopLeft__eb1s5`,
	"alignTopCenter": `image-module_alignTopCenter__oPHGL`,
	"alignTopRight": `image-module_alignTopRight__qfpYA`,
	"alignCenterLeft": `image-module_alignCenterLeft__tP4g_`,
	"alignCenter": `image-module_alignCenter__Iaebk`,
	"alignCenterRight": `image-module_alignCenterRight__JULUU`,
	"alignBottomLeft": `image-module_alignBottomLeft__XUPjh`,
	"alignBottomCenter": `image-module_alignBottomCenter__k2FX1`,
	"alignBottomRight": `image-module_alignBottomRight__MZd7d`
};
export default ___CSS_LOADER_EXPORT___;
